export default __webpack_public_path__ + "cfd248f5e923cfbd9e5bb020e20f81dc.jpg";